import { styled, Button, Typography, Box, Modal } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

interface ConfirmModalProps {
  open: boolean;
  iconElement?: React.ReactNode;
  title?: string;
  contentText?: string;
  contentElement?: React.ReactNode;
  onClose: () => void;
  onSubmit: () => void;
  onCancel?: () => void;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  open,
  iconElement,
  title,
  contentText,
  contentElement,
  onClose,
  onSubmit,
  onCancel
}: ConfirmModalProps) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <ModalContainer
        sx={{
          width: '400px'
        }}
      >
        {iconElement ? iconElement : <HelpOutlineIcon color="disabled" sx={{ fontSize: 100 }} />}
        <Box my={3}>
          <Typography variant="h5" mb={2}>
            {title ? title : 'ยืนยัน'}
          </Typography>
          {contentElement ? (
            contentElement
          ) : (
            <Typography>{contentText ? contentText : 'ยืนยันหรือไม่ ?'}</Typography>
          )}
        </Box>
        <Box display="flex">
          <Button variant="contained" color="primary" fullWidth onClick={onSubmit}>
            ยืนยัน
          </Button>
          &nbsp;
          <Button
            variant="contained"
            color="error"
            fullWidth
            onClick={onCancel ? onCancel : onClose}
          >
            ยกเลิก
          </Button>
        </Box>
      </ModalContainer>
    </Modal>
  );
};

export default ConfirmModal;

const ModalContainer = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  transform: 'translate(-50%, -50%)',
  backgroundColor: '#fff',
  boxShadow: '0 3px 10px rgb(0 0 0 / 0.2)',
  borderRadius: 16,
  padding: 16,
  maxWidth: '70%'
}));
